import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./PortalOrdersDrawerItemsMain";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import { userClaimInformation } from "../../../models/usersModel";
import { useSelector } from "react-redux";
import { View } from "../../../components/shared/Themed";
import Spinner from "../../../components/shared/Spinner";
import CustomerOrderScreen from "../../../screens/Customer/CustomerOrderScreen";
import CustomerOrderSummaryReport from "../../../screens/Customer/partials/CustomerOrderSummaryReport";
import KanbanPOCScreen from "../../../screens/KanbanScreen/KanbanPOCScreen";
import CustomerIssueScreen from "../../../screens/Customer/issues/CustomerIssueScreen";
import CustomerIssueDetailsReport from "../../../screens/Customer/issues/CustomerIssueDetailsReport";
import { useTranslation } from "../../../utils/useTranslation";
import CustomerAssignProductsScreen from "../../../screens/Customer/admin/assign/CustomerAssignProductsScreen";
import CustomerOrganizationsListScreen from "../../../screens/Customer/admin/organizations";
import { useAppTheme } from "../../../hooks/useAppTheme";
import CreateSalesOrderModal from "../../../screens/Customer/admin/CreateSalesOder";
import OrganizationOrdersScreen from "../../../screens/Customer/admin/organizations/orders";
import OrganizationOrderSummaryScreen from "../../../screens/Customer/admin/organizations/order-summary";

const Drawer = createDrawerNavigator();

export default function PortalOrdersDrawerNavigator() {
  const { colors } = useAppTheme();
  const { t } = useTranslation();
  const [userProfile, setUserProfile] = React.useState<userClaimInformation>();
  const { userInfo, currentRole } = useSelector(
    (state: any) => state.configurations,
  );
  const dimensions = useWindowDimensions();
  const [filteredDrawerItems, setFilteredDrawerItems] =
    React.useState(drawerItemsMain);

  React.useEffect(() => {
    if (userInfo) {
      setUserProfile(userInfo);
      setFilteredDrawerItems(
        drawerItemsMain.filter((item) =>
          process.env.NODE_ENV === "production"
            ? !["KanbanPOCScreen", "CustomerOrganizationsListScreen"].includes(
                item.key,
              )
            : true,
        ),
      );
    }
  }, [userInfo]);
  if (!userProfile || !currentRole) {
    return (
      <View
        style={{
          flexDirection: "column",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner
          size="small"
          color="#74BBFF"
          styles={{
            flexDirection: "row",
            justifySelf: "center",
            alignSelf: "center",
          }}
        />
      </View>
    );
  }

  return (
    <Drawer.Navigator
      screenOptions={{
        headerTintColor: colors.text,
        headerStyle: {
          backgroundColor: colors.surface,
          borderBottomWidth: 1,
          borderBottomColor: colors.border,
        },
        headerTitleStyle: {
          color: colors.text,
        },
        tabBarStyle: {
          backgroundColor: colors.surface,
          borderTopColor: colors.border,
        },
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front",
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={filteredDrawerItems} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: "CustomerOrganizationsListScreen",
          title: "Organizations",
        }}
        name="CustomerOrganizationsListScreen"
        component={CustomerOrganizationsListScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "CreateSalesOrderModal",
          title: "CreateSalesOrderModal",
        }}
        name="CreateSalesOrderModal"
        component={CreateSalesOrderModal}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "OrganizationOrdersScreen",
          title: "OrganizationOrders",
        }}
        name="OrganizationOrdersScreen"
        component={OrganizationOrdersScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "OrganizationOrderSummaryScreen",
          title: "OrganizationOrdersSummary",
        }}
        name="OrganizationOrderSummaryScreen"
        component={OrganizationOrderSummaryScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: t("customerorderreport"),
          title: t("customerOrderScreen"),
        }}
        name="CustomerOrderReport"
        component={CustomerOrderScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: t("customerordersummaryreport"),
          title: t("customerOrderSummaryReport"),
        }}
        name="CustomerOrderSummaryReport"
        component={CustomerOrderSummaryReport}
      />

      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          options={{
            drawerLabel: t("kanbanpocscreen"),
            title: t("kanbanpocscreen"),
          }}
          name="KanbanPOCScreen"
          component={KanbanPOCScreen}
        />
      )}

      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          options={{
            drawerLabel: t("customerissuedetailsreport"),
            title: t("customerIssueSummaryReport"),
          }}
          name="CustomerIssueDetailsReport"
          component={CustomerIssueDetailsReport}
        />
      )}

      <Drawer.Screen
        options={{
          drawerLabel: t("customerissuereport"),
          title: t("customerIssueScreen"),
        }}
        name="CustomerIssueReport"
        component={CustomerIssueScreen}
      />

      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          options={{
            drawerLabel: t("customerAssignProductsReport"),
            title: t("customerAssignProductsReport"),
          }}
          name="CustomerAssignProductsReport"
          component={CustomerAssignProductsScreen}
        />
      )}
    </Drawer.Navigator>
  );
}
